export const FormFields = {
    COMMENT: 'comment',
};

export const REMEDIATE_MAX_CLOUD_BOTS_ALLOWED = 5;
export const COMMENT_MAX_LENGTH = 200;
